export default "__VITE_ASSET__opSeUlOA__"